import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import GridItem from 'components/Grid/GridItem.js';

import styles from 'views/component/Styles.js';

import SimpleTable from 'views/component/SimpleTable.js';


const useStyles = makeStyles(styles);

export default function Operation(props) {
    const { factory, onDataChange, onSave } = props;
    const classes = useStyles();

    const handleSave = function (tempData) {
        if (onDataChange) {
            onDataChange(tempData);
        }
        if (onSave) {
            onSave(tempData);
        }
    }
    return (<GridItem xs={12} md={4} className={classes.collapsed}>
        <div className={classes.cellTitle}>
            <h4>Operation</h4>
        </div>
        <div className={classes.cellContentAps}>
            <SimpleTable domain="aps" tableName="operation" params={factory} insertAttr={factory}
                onSave={handleSave} droppable />
        </div>
    </GridItem>);
}